export const camelizeString = (text: string): string => {
  const divider = /[^a-zA-Z^0-9]/;
  return text
    ?.split(divider)
    ?.map((item, i) => (i ? `${item[0].toUpperCase()}${item.slice(1)}` : item))
    ?.join("");
};
